import { Center, Spinner, Text, VStack, useToast } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { trpcAdmin } from './lib/trpcAdmin';
import { safeRedirectParam } from '@duke-hq/libauth-client/safeRedirectParam';
import { useTenantContext } from './TenantContext';

export function MagicLinkPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const toast = useToast();
  const tenantCtx = useTenantContext();
  const magicLinkLogin = trpcAdmin.auth.magicLinkTokenLogin.useMutation();

  useEffect(() => {
    const allowedEnvironments = ['local', 'test'];
    if (!tenantCtx || !allowedEnvironments.includes(tenantCtx.environment)) {
      navigate('/login');
      return;
    }

    const token = searchParams.get('token');

    if (!token) {
      toast({
        title: 'Invalid magic link',
        description: 'No token provided',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      navigate('/login');
      return;
    }

    async function loginWithToken(token: string) {
      try {
        await magicLinkLogin.mutateAsync({ token });
        const redirectUrl = safeRedirectParam(searchParams);
        window.location.href = redirectUrl;
      } catch (error) {
        toast({
          title: 'Login failed',
          description: error instanceof Error ? error.message : 'Invalid or expired magic link',
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        navigate('/login');
      }
    }

    void loginWithToken(token);
  }, [searchParams, navigate, toast, magicLinkLogin]);

  return (
    <Center h="100vh">
      <VStack spacing={4}>
        <Spinner size="xl" />
        <Text>Logging in with magic link...</Text>
      </VStack>
    </Center>
  );
}
